module.exports = __webpack_public_path__ + "static/media/Bestemme.9419b3be.m4a";